import * as React from "react"

import { cn } from "@/shared/lib/utils"
import { DISABLED, FOCUS, INVALID, TRANSITION_COLOR } from "@/shared/ui/law"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "flex h-(--control-h) w-full min-w-0 rounded-md border border-border bg-background px-3 py-1 text-base md:text-sm",
        "placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground",
        "file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
        "hover:border-border-strong",
        "disabled:cursor-not-allowed",
        FOCUS,
        DISABLED,
        INVALID,
        TRANSITION_COLOR,
        className
      )}
      {...props}
    />
  )
}

export { Input }
